import { all, call, fork, put, takeLatest, delay, select } from "redux-saga/effects";
import * as actions from "@/AppRedux/actions/theme/themeType";
import * as actionsCreator from "@/AppRedux/actions/theme/";
import { ThemeData } from "@/AppRedux/actions/theme/themeType";
import { SagaIterator } from "redux-saga";
import { themeDefault } from "./themeMockupTemplate";

function* fetchTheme(action: actions.ThemeRequest): SagaIterator {
  try {
    const propcode = action.payload?.propcode;
    let theme: ThemeData | undefined;

    if (propcode) {
      const loadTheme = yield select((state) => state.theme);
      theme = loadTheme.data;
    }

    if (!theme) {
      theme = themeDefault as ThemeData;
    }
    yield put(actionsCreator.setThemeSuccess(theme));
  } catch (e: any) {
    const message = e?.message ?? "Failed to load theme";
    yield put(actionsCreator.setThemeFailure(message));
  }
}

function* saveTheme(action: actions.SaveThemeRequest): SagaIterator {
  try {
    // Mock API call
    yield delay(1000);
    console.log("Saving theme to API:", action.payload);
    yield put(actionsCreator.saveThemeSuccess());
  } catch (e: any) {
    const message = e?.message ?? "Failed to save theme";
    yield put(actionsCreator.saveThemeFailure(message));
  }
}

export function* watchFetchTheme() {
  yield takeLatest(actions.THEME_REQUEST, fetchTheme);
}

export function* watchSaveTheme() {
  yield takeLatest(actions.SAVE_THEME_REQUEST, saveTheme);
}

export default function* rootHotelProfileSaga() {
  yield all([fork(watchFetchTheme), fork(watchSaveTheme)]);
}
